const Tracker = require('./tracker');
const observe = require('../../lib/util/observe');
const template = require('./feature.tpl').default;

module.exports = DomClass(template, function Feature() {
	var _t = this;

	// TODO: consolidate tracking in the router.
	const tracker = new Tracker();

	observe(this, ['data-id', 'nav-context'], function(v) { _t.updateUrl(v); });

	this.updateUrl = () => {
		this.navContext = this['nav-context'] ? this['nav-context'] + '/' : '';
		var urlHash = '?' + this.navContext + this['data-id'];
		this.trackedUrl = location.pathname + urlHash;
		this.anchor.href = urlHash;
		this.anchor.body = this.name;
	};
	this.updateUrl();

	this.select = function() {
		tracker.trackPageview(_t.trackedUrl);
		on(_t.parentNode, 'selectFeature').fire(_t);
	};

	this.deselect = function() {
		on(_t.parentNode, 'selectFeature').fire(null);
	};

	this.handleSelect = function() {
		this.__dom.header.classList.add('selected');
		this.classList.add('selected');
		if (this.content.load) this.content.load();
		on(this, 'select').fire();
	};

	this.handleDeselect = function() {
		this.__dom.header.classList.remove('selected');
		this.classList.remove('selected');
		on(this, 'deselect').fire()
	};

	on(this.parentNode, 'selectFeature').then(function(feature) {
		if (feature == _t) {
			_t.handleSelect();
		} else {
			_t.handleDeselect();
		}
	});

	// TODO: try to figure out why this is the way it is and make it
	// NOT depend on a timeout...
	setTimeout(function() {
		var all = getNodes(_t.parentNode, 'db:feature');
		var first = all[0];
		_t.parentNode.insertBefore(_t.__dom.header, first);
	}, 1);

});
